import type { UserQuery } from 'codegen/generated/user'
import { userQueryKey, useUserQuery } from 'auth/hooks'
import ms from 'ms'
import { useQueryClient, keepPreviousData } from '@tanstack/react-query'

export type User = NonNullable<NonNullable<UserQuery['me']>['user']>

export const userQueryOptions = {
  placeholderData: keepPreviousData,
  staleTime: ms('15s'),
}

// eslint-disable-next-line cf-web/codegen-query-returns
export function useUser() {
  return useUserQuery(undefined, {
    ...userQueryOptions,
    select(data) {
      return data.me?.user
    },
  })
}

export function useUserId() {
  const { data } = useUser()
  return data?.id
}

export function useSetUserQuery() {
  const queryClient = useQueryClient()

  function setUserQuery(user: UserQuery) {
    queryClient.setQueryData<UserQuery>(userQueryKey, user)
  }

  return { setUserQuery }
}
